<template>
    <div class="text-center">
        <vue-timepicker
            ref="timePicker"
            format="HH:mm:ss"
            v-model="time"
            hide-clear-button
            auto-scroll
            input-width="100%"
            drop-direction="auto"
            :hour-label="$tc('common.hours', 2)"
            :minute-label="$tc('common.minutes', 2)"
            :second-label="$tc('common.seconds', 2)"
        />
    </div>
</template>

<script>

import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

export default {
    components: {VueTimepicker},
    name: "KimsaTimePicker",
    props: {
        value: {
            type: String,
            default: '00:00:00'
        }
    },
    data() {
        return {
            time: '00:00:00',
        }
    },
    mounted() {
        const vm = this
        vm.setDefault()
    },
    methods: {
        setDefault() {
            const vm = this
            vm.time = !vm.value ? '00:00:00' : vm.value
            vm.$refs.timePicker.toggleActive()
        },
    },
    watch: {
        time(val) {
            this.$emit('change', val)
        },
        value() {
            this.setDefault()
        },
    }

}
</script>

<style scoped>

::v-deep .vue__time-picker input.display-time {
    text-align: center;
    border-radius: 8px;
    height: 40px;
    font-size: 16px;
}

::v-deep .vue__time-picker .dropdown {
    border-radius: 8px;
    z-index: 99999999999;
}

::v-deep .vue__time-picker .dropdown ul li:not([disabled]).active {
    background: var(--v-secondary-base);
}

::v-deep .vue__time-picker .dropdown .hint, .vue__time-picker-dropdown .hint {
    position: sticky;
    top: 0;
    background-color: #FFFFFF;
}

</style>